module.exports = __webpack_public_path__ + "img/structure-tree.bd2c3d01.svg";